import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useGetPersonDocument } from 'core/types'

import ModelLink from './ModelLink'

type DocumentLinkProps = {
  documentId: string
}

const DocumentLink: FC<DocumentLinkProps> = ({ documentId }) => {
  const [_, { companyId, personId }] = useQueryApi()
  const { data: document, isLoading } = useGetPersonDocument({
    personId,
    documentDescriptorId: documentId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  const link =
    companyId &&
    personId &&
    `/companies/${companyId}/borrowers/${personId}/documents/${documentId}`

  return (
    <ModelLink
      id={documentId}
      isLoading={isLoading}
      link={link}
      model={document}
    />
  )
}

export default DocumentLink
